var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ejs-toolbar",
    { attrs: { id: "magnificationToolbar" } },
    [
      _c(
        "e-items",
        [
          _c("e-item", {
            attrs: {
              prefixIcon: _vm.icons.fitPage,
              id: "fitPage",
              tooltipText: _vm.texts.fitPage,
              click: _vm.pageFitEvent,
            },
          }),
          _c("e-item", {
            attrs: {
              prefixIcon: _vm.icons.zoomIn,
              id: "zoomIn",
              tooltipText: _vm.texts.zoomIn,
              click: _vm.zoomInEvent,
            },
          }),
          _c("e-item", {
            attrs: {
              prefixIcon: _vm.icons.zoomOut,
              id: "zoomOut",
              tooltipText: _vm.texts.zoomOut,
              click: _vm.zoomOutEvent,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }